import { buildCandidateKey } from './candidateKeys';

const normalizeText = (value = '') => String(value || '').trim();

export const REVIEWABLE_ORIGIN_TYPES = Object.freeze({
  TIMELINE_ENTRY: 'timeline_entry',
  CARE_SOURCE: 'care_source',
  KNOWLEDGE_ITEM: 'knowledge_item',
});

export const REVIEWABLE_ORIGIN_COLLECTIONS = Object.freeze({
  DAILY_LOGS: 'dailyLogs',
  CARE_SOURCES: 'careSources',
  KNOWLEDGE_ITEMS: 'knowledgeItems',
});

export const assertSavedReviewableOrigin = (origin = {}) => {
  if (!origin.sourceSaved) {
    throw new Error('Reviewable item origin must be saved before extraction review.');
  }
  if (!normalizeText(origin.id)) {
    throw new Error('Reviewable item origin is missing an id.');
  }
  if (!normalizeText(origin.type)) {
    throw new Error('Reviewable item origin is missing a type.');
  }
  if (!normalizeText(origin.collection)) {
    throw new Error('Reviewable item origin is missing a collection.');
  }

  return origin;
};

export const buildReviewableOrigin = ({
  id = '',
  type = '',
  collection = '',
  childId = '',
  sourceText = '',
  sourceSaved = true,
  metadata = {},
} = {}) => assertSavedReviewableOrigin({
  id: normalizeText(id),
  type: normalizeText(type),
  collection: normalizeText(collection),
  childId: normalizeText(childId),
  sourceText: normalizeText(sourceText),
  sourceSaved: Boolean(sourceSaved),
  metadata: metadata && typeof metadata === 'object' ? metadata : {},
});

export const buildReviewableCandidateShell = ({
  origin = {},
  domain = '',
  label = '',
  canonicalLabel = '',
  sourceAnchor = '',
  sourceText = '',
  allowedActions = [],
  suggestedAction = '',
  confidence = '',
  needsReview = true,
  payload = {},
  match = null,
  audit = {},
} = {}) => {
  const savedOrigin = assertSavedReviewableOrigin(origin);
  const cleanDomain = normalizeText(domain);
  const cleanLabel = normalizeText(label);
  const cleanSourceText = normalizeText(sourceText || savedOrigin.sourceText);
  const key = buildCandidateKey({
    originId: savedOrigin.id,
    domain: cleanDomain,
    label: cleanLabel,
    canonicalLabel,
    sourceAnchor: sourceAnchor || cleanSourceText,
  });

  return {
    schemaVersion: 1,
    key,
    candidateKey: key,
    origin: savedOrigin,
    domain: cleanDomain,
    label: cleanLabel,
    sourceText: cleanSourceText,
    confidence: normalizeText(confidence),
    needsReview: Boolean(needsReview),
    suggestedAction: normalizeText(suggestedAction),
    allowedActions: Array.isArray(allowedActions) ? allowedActions : [],
    payload: payload && typeof payload === 'object' ? payload : {},
    match,
    audit: audit && typeof audit === 'object' ? audit : {},
  };
};
